import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDiffTitle: {
        id: 'endorsement.common.views.history.Policy Changes',
        defaultMessage: 'Policy Changes',
    },
});
